import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ImagesLazyLoadDirective } from '../../../helpers/directives/images-lazy-load';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'widget-captain-more',
    templateUrl: './captain-more.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterModule, PipesModule, TranslocoModule, ImagesLazyLoadDirective]
})

export class CaptainMoreComponent {
  @Input() manager: any;
}
